import {NavItem} from '../model/component/nav-item';
import {Injectable} from '@angular/core';

@Injectable()
export class CommonConstants {


  //FÜR 24h & 3h Vorhersagen
  static VORHERSAGE_TABLE_COLUMNS_TO_DISPLAY = ['zeitspanne', 'wettersymbol', 'temperaturMin', 'temperaturMax', 'niederschlag', 'windrichtung', 'windgeschwindigkeit', 'accordionExpansion'];

  HORIZONTAL_ICON = 'horizontal_rule';

  NAV_ITEMS: NavItem[] = [
    {
      displayName: 'Vorhersagen',
      iconName: 'cloud',
      route: 'vorhersagen',
      children: [
        {
          displayName: 'Computer (MOS)',
          iconName: 'computer',
          route: 'vorhersagen/computer-mos',
          children: [
            {
              displayName: 'Übersicht',
              iconName: 'table_chart',
              route: 'vorhersagen/computer-mos/uebersicht',
            },
            {
              displayName: 'Automatisiert',
              iconName: 'donut_large',
              route: 'vorhersagen/computer-mos/automatisiert',
            }
          ]
        },

        {
          displayName: 'Meteorologe',
          iconName: 'remove_red_eye',
          route: 'vorhersagen/meteorologe',
          children: [
            {
              displayName: 'Druck/Wolken',
              iconName: 'speed',
              navLandName: 'Europa',
              route: 'vorhersagen/meteorologe/druckwolken'
            },
            {
              displayName: 'Temperaturen',
              iconName: 'thermostat',
              navLandName: 'Europa',
              route: 'vorhersagen/meteorologe/temperaturen'
            },
            {
              displayName: 'Reisewetter',
              iconName: 'surfing',
              navLandName: 'Europa',
              route: 'vorhersagen/meteorologe/reisewetter'
            },
            {
              displayName: 'Wetterberichte',
              iconName: 'notes',
              route: 'vorhersagen/meteorologe/wetterberichte'
            },
            {
              displayName: 'Gesundheit',
              iconName: 'scatter_plot',
              route: 'vorhersagen/meteorologe/gesundheit',
              children: [
                {
                  displayName: 'Biowetter',
                  iconName: 'horizontal_rule',
                  route: 'vorhersagen/meteorologe/gesundheit/biowetter',
                },
                {
                  displayName: 'Pollenflug',
                  iconName: 'horizontal_rule',
                  route: 'vorhersagen/meteorologe/gesundheit/pollenflug',
                },
                {
                  displayName: 'UV-Index',
                  iconName: 'horizontal_rule',
                  route: 'vorhersagen/meteorologe/gesundheit/uv-index',
                },
                {
                  displayName: 'Ozon',
                  iconName: 'horizontal_rule',
                  route: 'vorhersagen/meteorologe/gesundheit/ozon',
                },
              ]
            },

            {
              displayName: 'Freizeit',
              iconName: 'rowing',
              route: 'vorhersagen/meteorologe/freizeit',
              children: [
                {
                  displayName: 'Wassersportwetter',
                  iconName: 'sailing',
                  route: 'vorhersagen/meteorologe/freizeit/wassersportwetter',
                },
                {
                  displayName: 'Wintersportwetter',
                  iconName: 'snowmobile',
                  route: 'vorhersagen/meteorologe/freizeit/wintersportwetter',
                },

              ]
            },
            {
              displayName: 'Unwetter',
              iconName: 'flash_on',
              route: 'vorhersagen/meteorologe/unwetter',
            },
            {
              displayName: 'Sonstiges',
              iconName: 'web',
              route: 'vorhersagen/meteorologe/tagesthema'
            }
          ]
        }
      ]
    },

    {
      displayName: 'Messwerte',
      iconName: 'show_chart',
      route: 'messwerte'
    },

    {
      displayName: 'Grafiken',
      iconName: 'insert_chart',
      route: 'grafiken',
      children: [
        {
          displayName: 'Meteorologe',
          iconName: 'remove_red_eye',
          route: 'grafiken/meterologe',
          children: [
            {
              displayName: 'Wolken',
              iconName: this.HORIZONTAL_ICON,
              route: 'grafiken/meteorologe/wolken'
            },
            {
              displayName: 'Temperaturen',
              iconName: this.HORIZONTAL_ICON,
              route: 'grafiken/meteorologe/temperaturen'
            },
            {
              displayName: 'Wind',
              iconName: this.HORIZONTAL_ICON,
              route: 'grafiken/meteorologe/wind'
            },
            {
              displayName: 'Aussichten',
              iconName: this.HORIZONTAL_ICON,
              route: 'grafiken/meteorologe/aussichten'
            },
            {
              displayName: 'Sonstiges',
              iconName: this.HORIZONTAL_ICON,
              navLandName: 'Europa',
              route: 'grafiken/meteorologe/sonstiges'
            }
          ]
        },
        {
          displayName: 'Computer',
          iconName: 'computer',
          route: 'grafiken/computer',
          children: [
            {
              displayName: 'Druck',
              iconName: this.HORIZONTAL_ICON,
              navLandName: 'Europa',
              route: 'grafiken/computer/druck'
            },
            {
              displayName: 'Wolken',
              iconName: this.HORIZONTAL_ICON,
              route: 'grafiken/computer/wolken'
            },
            {
              displayName: 'Temperaturen',
              iconName: this.HORIZONTAL_ICON,
              route: 'grafiken/computer/temperaturen'
            },
            {
              displayName: 'Wind',
              iconName: this.HORIZONTAL_ICON,
              route: 'grafiken/computer/wind'
            },
            {
              displayName: 'Strömung',
              iconName: this.HORIZONTAL_ICON,
              route: 'grafiken/computer/stroemung'
            },
            {
              displayName: 'Regenmengen',
              iconName: this.HORIZONTAL_ICON,
              route: 'grafiken/computer/regenmengen'
            },
            {
              displayName: 'Sonstiges',
              iconName: this.HORIZONTAL_ICON,
              route: 'grafiken/computer/sonstiges'
            },
          ]
        }
      ]
    },

    {
      displayName: 'Radarbilder',
      iconName: 'photo',
      children: [
        {
          displayName: 'Aktuell',
          iconName: 'photo',
          route: 'radarbilder/aktuell'
        },
        {
          displayName: 'Vorhersagen',
          iconName: 'photo',
          route: 'radarbilder/vorhersagen'
        }
      ]
    },

    {
      displayName: 'Satbilder',
      iconName: 'photo',
      route: 'satbilder',
      children: [
        {
          displayName: 'Visible',
          iconName: 'horizontal_rule',
          route: 'satbilder/visible',
        },
        {
          displayName: 'Infrarot',
          iconName: 'horizontal_rule',
          route: 'satbilder/infrarot',
        }
      ]
    },
    {
      displayName: 'Unwetterwarnungen',
      iconName: 'warning',
      route: 'unwetterwarnungen'
    },
    {
      displayName: 'Tagesthema',
      iconName: 'article',
      route: 'tagesthema'
    },
    {
      displayName: 'Sonstiges',
      iconName: 'web_asset',
      route: 'sonstiges'
    },
  ];
}
